import React from 'react';
import { Card } from './ui/card';
import { Trophy } from 'lucide-react';

const Academies = ({ academies }) => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            Participating Academies
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Learn from coaches representing Europe's top football academies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {academies.map((academy, index) => (
            <Card 
              key={index}
              className="p-8 bg-white hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              {/* Academy Header */}
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-green-600 to-green-700 rounded-xl flex items-center justify-center text-white font-black text-2xl mr-4 flex-shrink-0">
                  {academy.logo}
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-black text-gray-900 mb-1">
                    {academy.name}
                  </h3>
                  <p className="text-sm text-green-600 font-semibold">{academy.country}</p>
                </div>
              </div>

              {/* Highlights */}
              <div className="mb-6">
                <h4 className="text-sm font-bold text-gray-900 mb-3 uppercase tracking-wider">Highlights</h4>
                <ul className="space-y-2">
                  {academy.highlights.map((highlight, idx) => (
                    <li key={idx} className="text-sm text-gray-600 flex items-start">
                      <span className="text-green-600 mr-2">•</span>
                      {highlight}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Success Stories */}
              <div className="border-t pt-4">
                <div className="flex items-center mb-2">
                  <Trophy className="h-4 w-4 text-yellow-500 mr-2" />
                  <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wider">Success Stories</h4>
                </div>
                <div className="space-y-1">
                  {academy.successStories.map((story, idx) => (
                    <p key={idx} className="text-xs text-gray-600">{story}</p>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Academies;